import React from "react";
import PropTypes from "prop-types";
import styled, { css } from "styled-components";
import Link from "next/link";
import { kebabCase } from "lodash";
import { useRouter } from "next/router";

const TabContainer = styled.ul`
  display: flex;
  width: 100%;
  padding: 0;
  margin: 2.5rem auto 1rem auto;

  ${({ theme }) => theme.mq.lg`
    width: 100%;
    max-width: 66rem;
    padding: 0 1rem;

    ${({ isLarge }) =>
      isLarge &&
      css`
        padding: 0;
      `}
  `}
`;

const LinkContainer = styled.li`
  display: flex;
  justify-content: center;
  list-style: none;
  margin: 0;
  width: 100%;
  min-width: 33%;
`;

const LinkTitle = styled.a`
  cursor: pointer;
  display: flex;
  justify-content: center;
  font-size: ${({ theme }) => theme.fontSize(2)};
  color: ${({ theme }) => theme.themeColors.goodfriendDark};
  text-align: center;
  width: 100%;
  padding-bottom: 0.75rem;
  border-bottom: 0.25rem solid ${({ theme }) => theme.themeColors.lightGrey};

  ${({ isActive }) =>
    isActive &&
    css`
      border-bottom: 0.25rem solid ${({ theme }) => theme.themeColors.primary};
      color: ${({ theme }) => theme.themeColors.primary};
    `}
`;

const NotiWrapper = styled.div`
  display: inline-block;
  padding: 0 0.25rem;
  margin-left: 0.25rem;
`;

const NotiContent = styled.span`
  align-items: center;
  background-color: ${({ theme }) => theme.themeColors.orange1};
  border-radius: 100%;
  color: ${({ theme }) => theme.themeColors.white};
  display: flex;
  font-size: 0.6875rem;
  justify-content: center;
  line-height: 1;
  min-width: 1.5rem;
  min-height: 1.5rem;
`;

const TabNavigation = (props) => {
  const { pageList, isQuery, isRoot, isLarge, className } = props;
  const { pathname, asPath } = useRouter();
  return (
    <TabContainer className={className} isLarge={isLarge}>
      {pageList?.map((page) => {
        let isActive = null;
        if (isQuery) {
          isActive = pathname === page.link.pathname;
        } else if (isRoot) {
          isActive = pathname === page.link;
        } else {
          isActive = asPath === page.link;
        }

        return (
          <LinkContainer key={`${page.id}-${kebabCase(page.title)}`}>
            <Link href={page.link}>
              <LinkTitle isActive={isActive}>
                <span>
                  {page.title}{" "}
                  {page.notification ? (
                    <NotiWrapper>
                      <NotiContent>{page.notification}</NotiContent>
                    </NotiWrapper>
                  ) : null}
                </span>
              </LinkTitle>
            </Link>
          </LinkContainer>
        );
      })}
    </TabContainer>
  );
};

export default TabNavigation;

// pageList should be the link suffix and the title of the page
TabNavigation.propTypes = {
  isRoot: PropTypes.bool,
  pageList: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  isQuery: PropTypes.bool,
  isLarge: PropTypes.bool,
  className: PropTypes.string,
};

TabNavigation.defaultProps = {
  isRoot: false,
  isQuery: false,
  isLarge: false,
  className: "",
};
